<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="Mercurys_Rise-5.html" xml:lang="en-US">
<div class="calibre1">
<p class="ct" id="toc_marker-6"><a href="#/OEBPS/Mercurys_Rise2#Contents-A">Epigraph</a></p>
<p class="body-center"><em class="italic">“Learning is like mercury, one of the most powerful<br class="calibre3"/>and excellent things in the world in skillful hands;<br class="calibre3"/>in unskillful, the most mischievous.”</em></p>
<p class="fp1">—Alexander Pope</p>
<p class="body"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Mercurys_Rise-5.vue?2dc145ef